// TODO: remove import from pages on this layer
import { PaymentsConditionsEnum } from '../../../../pages/payments/regular-and-requests/base/types/RegularAndRequests.types'

export const conditionsWhiteListTypes: string[] = [
  PaymentsConditionsEnum.EmailConfirmed,
  PaymentsConditionsEnum.MinBalanceAvailable,
  PaymentsConditionsEnum.ProfitForPeriodReceived,
  PaymentsConditionsEnum.KycVerified,
]
